export default {
  rss: {
    predpisZbierky: `${process.env.REACT_APP_PREDPIS_ZBIERKY_RSS_URL}`,
    legislativnyMaterial: `${process.env.REACT_APP_LEGISLATIVNY_MATERIAL_RSS_URL}`,
    aktuality: `${process.env.REACT_APP_AKTUALITY_RSS_URL}`,
  },
};
